import { forwardRef, type Ref, type SVGProps } from "react";
const IconDollarSignCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M7.51 24.49a12 12 0 1 1 17 0 12 12 0 0 1-17 0M6.1 25.9a14 14 0 1 0 0-19.8 14 14 0 0 0 0 19.8" />
    <path d="M20.75 18.57c0-1.75-1.1-2.74-3.67-3.32l-1.65-.36c-1.41-.36-2-.91-2-1.79s.86-1.57 2.11-1.7a3.2 3.2 0 0 1 3 1.47 1.09 1.09 0 0 0 1 .64c.56 0 .91-.29.91-.74a1.5 1.5 0 0 0-.08-.49c-.41-1.29-1.78-2.18-3.62-2.39V9.5a1 1 0 0 0-2 0v.44c-2.08.35-3.39 1.62-3.39 3.4s1.13 2.78 3.55 3.32l1.61.36c1.61.39 2.21.89 2.21 1.83s-.83 1.68-2.22 1.76a3.45 3.45 0 0 1-3.26-1.49 1 1 0 0 0-1-.65c-.6 0-1 .32-1 .85a1.4 1.4 0 0 0 .1.49 3.92 3.92 0 0 0 3.35 2.27v.43a1 1 0 0 0 2 0v-.38c2.03-.2 4.05-1.22 4.05-3.56" />
  </svg>
);
const ForwardRef = forwardRef(IconDollarSignCircleOutlineSVG);
ForwardRef.displayName = "IconDollarSignCircleOutline";
export { ForwardRef as IconDollarSignCircleOutline };
